import React from "react";
import { Facebook, Linkedin, Instagram, Twitter } from "lucide-react";
import useReveal from "../hooks/useReveal";
import { TEAM } from "../mock";

export default function Team() {
  const ref = useReveal();

  return (
    <section id="team" className="section-pad" style={{ background: "#f5f8fd" }} ref={ref}>
      <div className="container mx-auto px-4 max-w-[1200px]">
        <div className="site-heading text-center max-w-[820px] mx-auto mb-14">
          <h4>Team</h4>
          <h2>{TEAM.heading}</h2>
          <p>{TEAM.text}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {TEAM.members.map((m, i) => (
            <div
              key={m.name}
              className="team-card reveal"
              style={{ transitionDelay: `${i * 0.12}s` }}
            >
              <div className="team-thumb">
                <img src={m.img} alt={m.name} />
                <div className="team-social">
                  <a href="#" aria-label="Facebook"><Facebook size={16} /></a>
                  <a href="#" aria-label="LinkedIn"><Linkedin size={16} /></a>
                  <a href="#" aria-label="Twitter"><Twitter size={16} /></a>
                  <a href="#" aria-label="Instagram"><Instagram size={16} /></a>
                </div>
              </div>
              <div className="p-6 text-center">
                <h4 className="text-lg font-semibold" style={{ color: "#141b34" }}>
                  {m.name}
                </h4>
                <span className="text-sm text-[#1b6ef3] font-medium">{m.role}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
